/* EU Right of Withdrawal — state machine + form submission.

   States across the page:
     • [data-wdl-pane="intro"] sections  → visible by default (intro + qualifies)
     • [data-wdl-pane="form"]  section   → hidden until #wdl-start clicked

   Step swap is required by EU Directive 2011/83 — the customer must
   explicitly confirm BEFORE submission, so the form can't sit on first paint.

   On submit:
     1. Validate (HTML5 + required consent checkboxes)
     2. Generate WDL-YYYY-ORDERID reference client-side
     3. Klaviyo identify + track "EU Withdrawal Submitted" — fires the
        durable-medium transactional email via the Klaviyo flow.
     4. POST to /apps/withdrawal/log — fire-and-forget audit trail.
     5. POST to the optional Shopify Flow webhook (back-up channel).
     6. Redirect to /pages/withdrawal-confirmed?ref=<reference>. */
(function(){
  var formSec = document.getElementById('wdl-form-section');
  if (!formSec) return;
  var form    = document.getElementById('wdl-form');
  var startBtn= document.getElementById('wdl-start');
  var backBtn = document.getElementById('wdl-back');
  var errEl   = document.getElementById('wdl-error');

  function showIntro(){
    document.querySelectorAll('[data-wdl-pane="intro"]').forEach(function(el){
      el.removeAttribute('hidden');
    });
    formSec.setAttribute('hidden', '');
    try { window.scrollTo({ top: 0, behavior: 'smooth' }); } catch(_) {}
  }

  function showForm(){
    document.querySelectorAll('[data-wdl-pane="intro"]').forEach(function(el){
      el.setAttribute('hidden', '');
    });
    formSec.removeAttribute('hidden');
    try { formSec.scrollIntoView({behavior:'smooth', block:'start'}); } catch(_) {}
  }

  if (startBtn) startBtn.addEventListener('click', showForm);
  if (backBtn)  backBtn.addEventListener('click',  showIntro);

  function genReference(orderNumber){
    var year = new Date().getFullYear();
    var ord  = (orderNumber || '').replace(/[^A-Za-z0-9-]/g, '');
    if (!ord) ord = Math.floor(100000 + Math.random()*900000);
    return 'WDL-' + year + '-' + ord;
  }

  function showError(msg){
    if (!errEl) return alert(msg);
    errEl.textContent = msg;
    errEl.removeAttribute('hidden');
  }
  function clearError(){
    if (!errEl) return;
    errEl.setAttribute('hidden', '');
    errEl.textContent = '';
  }

  function fireKlaviyoEvent(payload){
    // Klaviyo Onsite SDK (_learnq). Fires identify + track. The
    // 'EU Withdrawal Submitted' event triggers the transactional
    // flow that emails the durable-medium confirmation.
    try {
      var _learnq = window._learnq = window._learnq || [];
      _learnq.push(['identify', {
        '$email': payload.email,
        '$first_name': (payload.full_name || '').split(' ')[0]
      }]);
      _learnq.push(['track', 'EU Withdrawal Submitted', payload]);
      console.log('[Withdrawal] Klaviyo event fired: EU Withdrawal Submitted');
    } catch(err) {
      console.warn('[Withdrawal] Klaviyo push failed', err);
    }
  }

  function postAuditLog(payload){
    // App proxy endpoint that writes to the order metafield
    // custom.eu_withdrawal. Fire-and-forget — if the app isn't
    // deployed yet, this 404s silently and the customer still
    // gets the confirmation page + email.
    try {
      return fetch('/apps/withdrawal/log', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true
      }).catch(function(err){
        console.warn('[Withdrawal] /apps/withdrawal/log POST failed', err);
        return null;
      });
    } catch(_) { return Promise.resolve(); }
  }

  function postFlowWebhook(payload){
    var webhookUrl   = formSec.dataset.webhookUrl   || '';
    var webhookToken = formSec.dataset.webhookToken || '';
    if (!webhookUrl) return Promise.resolve();
    var headers = { 'Accept': 'application/json', 'Content-Type': 'application/json' };
    if (webhookToken) headers['X-Api-Key'] = webhookToken;
    return fetch(webhookUrl, {
      method: 'POST',
      headers: headers,
      body: JSON.stringify(payload),
      keepalive: true
    }).catch(function(err){
      console.warn('[Withdrawal] Flow webhook POST failed', err);
      return null;
    });
  }

  if (!form) return;
  form.addEventListener('submit', function(e){
    e.preventDefault();
    clearError();

    if (!form.checkValidity()){
      form.reportValidity();
      return;
    }

    var data = {};
    new FormData(form).forEach(function(v, k){ data[k] = v; });

    if (!data.consent_directive || !data.consent_exempt) {
      showError("Please tick the two consent statements before submitting.");
      return;
    }

    var now = new Date();
    var ref = genReference(data.order_number);
    var refundDueBy = new Date(now.getTime() + 14*24*60*60*1000);

    var submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.dataset.originalLabel = submitBtn.textContent;
      submitBtn.innerHTML = '<span>Submitting…</span>';
    }

    // Parse multi-line items into an array (Klaviyo can join them in the
    // email with {{ event.items|join:" · " }}).
    var itemsArr = (data.items || '')
      .split(/\r?\n/).map(function(s){ return s.trim(); }).filter(Boolean);

    var payload = {
      reference:     ref,
      order_id:      data.order_number,
      order_number:  data.order_number,
      name:          data.full_name,
      full_name:     data.full_name,
      email:         data.email,
      items:         itemsArr,
      items_text:    data.items,
      delivery_date: data.delivery_date,
      country:       data.country,
      postcode:      data.postcode,
      reason:        data.reason,
      consent_directive: !!data.consent_directive,
      consent_exempt:    !!data.consent_exempt,
      opt_in_skin_team:  !!data.opt_in_skin_team,
      submitted_at:  now.toISOString(),
      refund_due_by: refundDueBy.toISOString(),
      source:        'storefront-withdrawal'
    };

    // 1. Klaviyo identify + track → triggers the transactional email flow.
    fireKlaviyoEvent(payload);

    // 2. Audit log to order metafield via app proxy (fire-and-forget).
    postAuditLog(payload);

    // 3. Optional back-up channel — Shopify Flow webhook (configurable
    //    in the section settings). Empty by default, ignored if blank.
    postFlowWebhook(payload);

    // 4. Redirect to the dedicated confirmation page with the reference
    //    in the query string. The page reads ?ref= and renders.
    setTimeout(function(){
      window.location.href = '/pages/withdrawal-confirmed?ref=' + encodeURIComponent(ref);
    }, 250);
  });
})();
